import { useMemo } from "react";

export default function HallucinationHighlighter({ text, hallucinatedSpans = [] }) {
  const highlightedText = useMemo(() => {
    if (!hallucinatedSpans || hallucinatedSpans.length === 0) {
      return [{ text, highlighted: false }];
    }

    const segments = [];
    let lastIndex = 0;

    // Sort spans by their position in text
    const sortedSpans = hallucinatedSpans
      .map(span => ({
        span,
        index: text.toLowerCase().indexOf(span.toLowerCase())
      }))
      .filter(item => item.index !== -1)
      .sort((a, b) => a.index - b.index);

    sortedSpans.forEach(({ span, index }) => {
      // Add text before the span
      if (index > lastIndex) {
        segments.push({
          text: text.slice(lastIndex, index),
          highlighted: false
        });
      }

      // Add the highlighted span
      segments.push({
        text: text.slice(index, index + span.length),
        highlighted: true
      });

      lastIndex = index + span.length;
    });

    // Add remaining text
    if (lastIndex < text.length) {
      segments.push({
        text: text.slice(lastIndex),
        highlighted: false
      });
    }

    return segments.length > 0 ? segments : [{ text, highlighted: false }];
  }, [text, hallucinatedSpans]);

  return (
    <div className="text-sm leading-relaxed" data-testid="hallucination-highlighter">
      {highlightedText.map((segment, idx) => (
        segment.highlighted ? (
          <mark 
            key={idx}
            className="hallucination-highlight px-0.5 rounded-sm"
            title="This text may not be supported by the retrieved context"
          >
            {segment.text}
          </mark>
        ) : (
          <span key={idx}>{segment.text}</span>
        )
      ))}
    </div>
  );
}
